<template>
  <div class="rl__search">
    <div class="rl__search-content">
      <input class="rl__search-input" aria-label="Search Library"  type="text" :placeholder= "$t('searchPlaceholder')" v-on:keyup="updateChange" :value="searchValue"/>
      <a class="ico-ctx-search" href="javascript:void(0);" aria-label="Search" aria-hidden="false" @click="onSearch(searchValue)"></a>
      <span class="rl__search-close" v-bind:class="{ show: searchValue !== '' }">
        <a @click="clear" class="ico-ctx-close" href="javascript:void(0);" aria-label="Close Search box" aria-hidden="true"></a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      isClicked: false,
      searchValue: ""
    };
  },
  props: {
    onSearch: {
      type: Function,
    },
    clearSearch: {
      type: Function,
    },
    reset: Boolean,
    resetView: {
      type: Function
    }
  },
  methods: {
    updateChange(event) {
      this.searchValue = event.target.value;
      if (event.keyCode === 13) this.onSearch(this.searchValue);
    },
    clear() {
      this.resetView();
    },
  },
  watch: {
    reset(newVal) {
      if (newVal) this.searchValue = "";
    }
  },
};
</script>

<style lang="scss">
@import "../css/_global.scss";

.rl__search {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1.5rem;
  a {
    color: black;
    padding-top: 2px;

    &:hover {
      border-bottom: none;
    }
  }

  &-input {
    border: none;
    outline: none;
    width: 100%;
    height: 100%;
    padding: 0;

    &:focus {
      outline: none;
    }
  }

  &-content {
    border: 1px solid black;
    padding: 10px;
    width: 60%;
    display: flex;
  }
}

.rl__search-input ~ .rl__search-close {
   display: none;
   padding-left: 5px;
  }

.rl__search-close > span {
  padding-right: 5px;
}

.rl__search-input:focus ~ .rl__search-close,
.ico-ctx-search:focus ~ .rl__search-close {
  display: flex;
}

.rl__search-close > .ico-ctx-close {
    border-left: 1px solid black;
    margin-left: 6px;
    padding-left: 10px;
}

.rl__search-input ~ .rl__search-close.show,
.ico-ctx-search ~ .rl__search-close.show {
  display: flex;
}

input::-ms-clear {
    display: none;
}
</style>

